var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { API } from 'globals/api';
import { CAREGIVER_ASSESSMENT_END_POINTS, USER_SERVICE_ENDPOINTS, } from 'globals/apiEndPoints';
import { APIMethod, Roles } from 'globals/enums';
import { DATE_FORMAT, TIME_FORMAT } from 'globals/global.constants';
import moment from 'moment';
export var postCaregiverListService = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, API({
                        url: CAREGIVER_ASSESSMENT_END_POINTS.POST_CAREGIVER_LIST,
                        method: APIMethod.Post,
                        data: data,
                    })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response];
            case 2:
                error_1 = _a.sent();
                console.log(error_1);
                throw error_1;
            case 3: return [2 /*return*/];
        }
    });
}); };
export var getAssessmentReport = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, API({
                    method: 'GET',
                    url: CAREGIVER_ASSESSMENT_END_POINTS.GET_CAREGIVER_REPORT,
                    params: params,
                })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.data];
        }
    });
}); };
export var getAssessmentHistoryService = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, API({
                    method: 'GET',
                    url: CAREGIVER_ASSESSMENT_END_POINTS.GET_CAREGIVER_HISTORY,
                    params: params,
                })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.data];
        }
    });
}); };
export function getCaregiverAssessmentService(param, getState) {
    return __awaiter(this, void 0, Promise, function () {
        var response, userRole, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    response = [];
                    userRole = getState().auth.userRole;
                    if (!(!userRole.includes(Roles.BDM) &&
                        !userRole.includes(Roles.FACILITY_AGENT))) return [3 /*break*/, 4];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, API({
                            url: "".concat(CAREGIVER_ASSESSMENT_END_POINTS.GET_BLANK_CAREGIVER_ASSESSMENT),
                            method: 'get',
                            params: param,
                        })];
                case 2:
                    response = _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _a.sent();
                    throw e_1;
                case 4: return [2 /*return*/, mapCaregiverAssessmentPayload(response.data)];
            }
        });
    });
}
var mapCaregiverAssessmentPayload = function (response) {
    var formData = response.form;
    var caregiverStrainForm = mapCaregiverFormData(formData);
    var date = moment
        .utc(response.modification_date)
        .tz(moment.tz.guess())
        .format(DATE_FORMAT);
    var time = moment
        .utc(response.modification_date)
        .tz(moment.tz.guess())
        .format(TIME_FORMAT);
    return {
        surveys: caregiverStrainForm,
        assessmentId: response.assessment_id,
        versionNumber: response.version,
        assessmentStatus: response.assessment_status,
        dateTime: "".concat(date, " ").concat(time),
        careAgentId: response.care_agent_id,
    };
};
export var mapCaregiverFormData = function (caregiverStrainFormData) {
    var payloadData = [];
    caregiverStrainFormData === null || caregiverStrainFormData === void 0 ? void 0 : caregiverStrainFormData.forEach(function (item) {
        payloadData = __spreadArray(__spreadArray([], payloadData, true), [item], false);
    });
    return payloadData;
};
export function getAllCaregiverListServiceAdmin(params) {
    return __awaiter(this, void 0, Promise, function () {
        var response, caregivers, error_2;
        var _a, _b, _c, _d, _e, _f;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    _g.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, API({
                            url: USER_SERVICE_ENDPOINTS.GET_ALL_CAREGIVER_LIST,
                            method: 'get',
                            params: params,
                        })];
                case 1:
                    response = _g.sent();
                    caregivers = mapAllCaregiverListPayload(((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.caregivers) || []);
                    return [2 /*return*/, {
                            lastEvaluatedKey: ((_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.lastEvaluatedKey) || '',
                            application_code: (_d = (_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.application_code) !== null && _d !== void 0 ? _d : 200,
                            data: { caregivers: caregivers },
                            message: ((_e = response === null || response === void 0 ? void 0 : response.data) === null || _e === void 0 ? void 0 : _e.message) || '',
                            error: !!((_f = response === null || response === void 0 ? void 0 : response.data) === null || _f === void 0 ? void 0 : _f.error),
                        }];
                case 2:
                    error_2 = _g.sent();
                    console.error('Error fetching caregiver list:', error_2);
                    throw error_2;
                case 3: return [2 /*return*/];
            }
        });
    });
}
var mapAllCaregiverListPayload = function (data) {
    if (!Array.isArray(data))
        return [];
    return data.map(function (cg) {
        var _a, _b, _c;
        var associations = Array.isArray(cg === null || cg === void 0 ? void 0 : cg.associations)
            ? cg.associations.map(function (assoc) {
                var _a, _b, _c;
                return ({
                    senior_id: (assoc === null || assoc === void 0 ? void 0 : assoc.senior_id) || '',
                    caregiver_type: (assoc === null || assoc === void 0 ? void 0 : assoc.caregiver_type) || 'secondary',
                    relationship_with_senior: (assoc === null || assoc === void 0 ? void 0 : assoc.relationship_with_senior) || '',
                    account_id: (assoc === null || assoc === void 0 ? void 0 : assoc.account_id) || '',
                    senior_name: {
                        first_name: ((_a = assoc === null || assoc === void 0 ? void 0 : assoc.senior_name) === null || _a === void 0 ? void 0 : _a.first_name) || '',
                        middle_name: ((_b = assoc === null || assoc === void 0 ? void 0 : assoc.senior_name) === null || _b === void 0 ? void 0 : _b.middle_name) || null,
                        last_name: ((_c = assoc === null || assoc === void 0 ? void 0 : assoc.senior_name) === null || _c === void 0 ? void 0 : _c.last_name) || '',
                    },
                });
            })
            : [];
        return {
            caregiver_id: (cg === null || cg === void 0 ? void 0 : cg.caregiver_id) || '',
            user_id: (cg === null || cg === void 0 ? void 0 : cg.user_id) || '',
            name: {
                first_name: ((_a = cg === null || cg === void 0 ? void 0 : cg.name) === null || _a === void 0 ? void 0 : _a.first_name) || '',
                middle_name: ((_b = cg === null || cg === void 0 ? void 0 : cg.name) === null || _b === void 0 ? void 0 : _b.middle_name) || null,
                last_name: ((_c = cg === null || cg === void 0 ? void 0 : cg.name) === null || _c === void 0 ? void 0 : _c.last_name) || '',
            },
            mobile_number: (cg === null || cg === void 0 ? void 0 : cg.mobile_number) || '',
            email: (cg === null || cg === void 0 ? void 0 : cg.email) || '',
            account_status: (cg === null || cg === void 0 ? void 0 : cg.account_status) || 'inactive',
            is_active: !!(cg === null || cg === void 0 ? void 0 : cg.is_active),
            is_first_login: !!(cg === null || cg === void 0 ? void 0 : cg.is_first_login),
            associations: associations,
            senior_name: '-',
            caregiver_type: '-',
            relationWithSenior: '-',
        };
    });
};
